module.exports = __webpack_public_path__ + "img/jagelnickiy.b3b477b6.jpg";